// CreativeStudio offers to install itself as an app from its help panel. The studio is part of
// PCake here, and PCake has its own install prompt, so the studio never offers one.
export const canOfferInstall = () => false;
export const promptInstall = () => false;
